import {INVOICE} from "../invoice/Constants"
import {QUOTE} from "../quote/Constants"
import {CREDIT_MEMO} from "../credit-memo/Constants"
import {DOCUMENT_TYPE} from "../Constants"

export const PRICE_LIST = "price-list"

const PRICE_LIST_OBJECT_TYPE = [INVOICE, QUOTE, CREDIT_MEMO] as const
export type PRICE_LIST_OBJECT_TYPE = (typeof PRICE_LIST_OBJECT_TYPE)[number]
export const isTypePriceListObject = (x: DOCUMENT_TYPE): x is PRICE_LIST_OBJECT_TYPE =>
    PRICE_LIST_OBJECT_TYPE.includes(x as PRICE_LIST_OBJECT_TYPE)

const PRICE_LIST_OBJECT_WITH_OPTIONAL_PAYMENT = [INVOICE, QUOTE] as const
export type PRICE_LIST_OBJECT_WITH_OPTIONAL_PAYMENT = (typeof PRICE_LIST_OBJECT_WITH_OPTIONAL_PAYMENT)[number]
export const isTypePriceListObjectWithOptionalPayment = (x: PRICE_LIST_OBJECT_TYPE):
    x is PRICE_LIST_OBJECT_WITH_OPTIONAL_PAYMENT =>
    PRICE_LIST_OBJECT_WITH_OPTIONAL_PAYMENT.includes(x as PRICE_LIST_OBJECT_WITH_OPTIONAL_PAYMENT)




// WEBPACK FOOTER //
// ./src/state/price-list/Constants.ts